export type IDynamicsFormMapping =
  | {
      FormFieldName: string;
      DataverseFieldName: string;
    }
  | {
      DataverseFieldName: string;
      DataverseFieldValue: unknown;
    };

export interface IDynamicsFormConfig {
  FormId: string;
  FormApiUrl: string;
}

export type IDynamicsOptionSet = {
  DataverseValue: number;
  Label: string;
}[];

export enum DynamicsLeadType {
  buyer = 10,
  seller = 11,
  service = 12,
  parts = 13,
  marketing = 15,
}

export enum DynamicsLeadSource {
  phoneCall = 1000,
  ManufacturerLead = 1001,
  walkInDriveBy = 31,
  rvShowConsumerEvent = 40,
  website = 41,
  downPhoneCall = 1,
  internet = 4,
  facebookMarket = 5,
  googleSearch = 6,
  facebook = 7,
  instagram = 8,
  stackAdapt = 9,
  tvRadioBroadcast = 10,
  rvusa = 11,
  rvtrader = 12,
  aimbase = 13,
  rvuniverse = 14,
  rvt = 15,
  sssolutions = 16,
  email = 17,
  directGoogleBingSearch = 18,
  googleMyBusiness = 19,
  socialMedia = 20,
  recvan = 21,
  rvshowusa = 22,
  buyerDepartment = 23,
  referral = 24,
  repeatCustomer = 25,
  service = 26,
  rollick = 27,
  traderInteractive = 28,
  engageToSell = 29,
  referralRepeatCustomer = 30,
}

export enum DynamicsDealershipType {
  phoenix = 10,
  mesa = 11,
  tucson = 12,
  fremont = 13,
  westSacramento = 14,
  sanDiego = 15,
  albuquerque = 16,
  orlando = 17,
  portStLucie = 18,
  ftMyers = 19,
  davie = 20,
}

export enum DynamicsServiceCenterType {
  phoenix = 10,
  tucson = 11,
  elCajon = 12,
  davis = 13,
  orlando = 14,
  portStLucie = 15,
  ftMyers = 16,
  albuquerque = 17,
}

export enum DynamicsDealershipContactType {
  any = 1,
  email = 2,
  call = 3,
  text = 6,
}
